import { IncomeDocument } from '@/types/income'
import { ExpenseDocument } from '@/types/expense'

import api from './config'

import { fileToBase64 } from '@/utils/file'

const receiptsAPI = {
  analyzeIncome: async (file: File) => {
    const base64 = await fileToBase64(file)
    
    const response = await api.post<IncomeDocument>(
      '/receipts/analyze_income',
      {
        receipt: {
          file: base64,
          filename: file.name,
          content_type: file.type
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  },
  analyzeExpense: async (file: File) => {
    const base64 = await fileToBase64(file)

    const response = await api.post<ExpenseDocument>(
      '/receipts/analyze_expense',
      {
        receipt: {
          file: base64,
          filename: file.name,
          content_type: file.type
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  },
}

export default receiptsAPI